
const Index = r => require.ensure([], () => r(require('./index')), 'group-topic')
const Hooli = r => require.ensure([], () => r(require('./Hooli')), 'group-topic')
const Consultative = r => require.ensure([], () => r(require('./Consultative')), 'group-topic')
const Uroom = r => require.ensure([], () => r(require('./Uroom')), 'group-topic')
const OfficialRecommendIndex = r => require.ensure([], () => r(require('./OfficialRecommend/Index')), 'group-topic')
const UTSInsearch = r => require.ensure([], () => r(require('./UTSInsearch')), 'group-topic')
const AustraliaClass = r => require.ensure([], () => r(require('./AustraliaClass')), 'group-topic')
const Adld = r => require.ensure([], () => r(require('./Adld')), 'group-topic')
const CreativeCamp = r => require.ensure([], () => r(require('./creativeCamp')), 'group-topic')
const WuLunGong = r => require.ensure([], () => r(require('./WuLunGong')), 'group-topic')
const Oster = r => require.ensure([], () => r(require('./Oster')), 'group-topic')
const Queensland = r => require.ensure([], () => r(require('./Queensland')), 'group-topic')
const KenTe = r => require.ensure([], () => r(require('./KenTe')), 'group-topic')
const Camp = r => require.ensure([], () => r(require('./Camp')), 'group-topic')
const Nske = r => require.ensure([], () => r(require('./Nske')), 'group-topic')
const Mns = r => require.ensure([], () => r(require('./Mns')), 'group-topic')
const Lundon = r => require.ensure([], () => r(require('./Lundon')), 'group-topic')
const Camp3 = r => require.ensure([], () => r(require('./Camp3')), 'group-topic')
const Sydney = r => require.ensure([], () => r(require('./Sydney')), 'group-topic')
const WesAustralia = r => require.ensure([], () => r(require('./WesAustralia')), 'group-topic')
const Macquarie = r => require.ensure([], () => r(require('./Macquarie')), 'group-topic')
const Southampton = r => require.ensure([], () => r(require('./Southampton')), 'group-topic')
const Winnipeg = r => require.ensure([], () => r(require('./Winnipeg')), 'group-topic')
const Queensland2 = r => require.ensure([], () => r(require('./Queensland2')), 'group-topic')
const Adelaide = r => require.ensure([], () => r(require('./Adelaide')), 'group-topic')
const Creation = r => require.ensure([], () => r(require('./Creation')), 'group-topic')
const GetCertificate = r => require.ensure([], () => r(require('./GetCertificate')), 'group-topic')
const Flinders = r => require.ensure([], () => r(require('./Flinders')), 'group-topic')
const Australia = r => require.ensure([], () => r(require('./Australia')), 'group-topic')
const KunZhou = r => require.ensure([], () => r(require('./KunZhou')), 'group-topic')
const Monash = r => require.ensure([], () => r(require('./Monash')), 'group-topic')
const EQI = r => require.ensure([], () => r(require('./EQI')), 'group-topic')
const UP = r => require.ensure([], () => r(require('./UP')), 'group-topic')

//2022
const Diken = r => require.ensure([], () => r(require('./Diken')), 'group-topic')
const LD = r => require.ensure([], () => r(require('./LD')), 'group-topic')
const Flds = r => require.ensure([], () => r(require('./Flds')), 'group-topic')
const UTS = r => require.ensure([], () => r(require('./UTS')), 'group-topic')
const MUM = r => require.ensure([], () => r(require('./MUM')), 'group-topic')
const SJGSA = r => require.ensure([], () => r(require('./SJGSA')), 'group-topic')
const Wlg = r => require.ensure([], () => r(require('./Wlg')), 'group-topic')
const Xa = r => require.ensure([], () => r(require('./Xa')), 'group-topic')
const Tsmny = r => require.ensure([], () => r(require('./Tsmny')), 'group-topic')
const newMns = r => require.ensure([], () => r(require('./newMns')), 'group-topic')
const newQsl = r => require.ensure([], () => r(require('./newQsl')), 'group-topic')
const mnsB = r => require.ensure([], () => r(require('./mnsB')), 'group-topic')
const Xnwes = r => require.ensure([], () => r(require('./Xnwes')), 'group-topic')
const Hftw=r => require.ensure([], () => r(require('./Hftw')), 'group-topic')
const mnsdx=r => require.ensure([], () => r(require('./Mnsdx')), 'group-topic')
const kslkj=r => require.ensure([], () => r(require('./Kslkj')), 'group-topic')
const adldweek=r => require.ensure([], () => r(require('./Adldweek.vue')), 'group-topic')
const wlgdx=r => require.ensure([], () => r(require('./Wlgdx.vue')), 'group-topic')
const akldx=r => require.ensure([], () => r(require('./Akldx.vue')), 'group-topic')
const xnkj=r=> require.ensure([], () => r(require('./xnkj.vue')), 'group-topic')
const wlgdxbymar=r => require.ensure([], () => r(require('./WlgdxByMar.vue')), 'group-topic')
const kslbymar=r => require.ensure([], () => r(require('./KslByMar.vue')), 'group-topic')
const xnwrsMar=r => require.ensure([], () => r(require('./xnwrsMar.vue')), 'group-topic')
const kpldsMar=r => require.ensure([], () => r(require('./kpldsMar.vue')), 'group-topic')
const dkdxMar=r => require.ensure([], () => r(require('./dkdxMar.vue')), 'group-topic')
const KslkjdxMar=r => require.ensure([], () => r(require('./KslkjdxMar.vue')), 'group-topic')
const Nwales=r=>require.ensure([],()=>r(require('./Nwales.vue')), 'group-topic')
export default { //
  path: '/topic',
  component: Index,
  children: [
    {
      path: 'hooli',
      name: 'Hooli',
      component: Hooli
    },
    {
      path: 'consultative',
      name: 'Consultative',
      component: Consultative
    },
    {
      path: 'uroom',
      name: 'Uroom',
      component: Uroom
    },
    {
      path: 'official-recommend/index',
      name: 'OfficialRecommendIndex',
      component: OfficialRecommendIndex
    },
    {
      meta: {
        title: '快来参加UTS:Insearch学院专场活动，我每天都领现金$红包$，真香！~'
      },
      path: 'UTSInsearch',
      name: 'UTSInsearch',
      component: UTSInsearch
    },
    {
      meta: {
        title: '看直播领红包！快来参加澳大利亚国立大学明星教授公开课！'
      },
      path: 'AustraliaClass',
      name: 'AustraliaClass',
      component: AustraliaClass
    },
    {
      meta: {
        title: '阿德莱德大学院校日'
      },
      path: 'adld',
      name: 'Adld',
      component: Adld
    },
    {
      meta: {
        title: '名校顾问创造营-领取你的院校官方认证证书'
      },
      path: 'creative-camp',
      name: 'CreativeCamp',
      component: CreativeCamp
    },
    {
      meta: {
        title: '伍伦贡大学院校日！冲关赢好礼！'
      },
      path: 'wulungong',
      name: 'WuLunGong',
      component: WuLunGong
    },
    {
      meta: {
        title: '英国奥斯特大学，新年红包大派发！'
      },
      path: 'oster',
      name: 'Oster',
      component: Oster
    },
    {
      meta: {
        title: '校口常开！昆士兰大学花式炫技进行中'
      },
      path: 'queensland',
      name: 'Queensland',
      component: Queensland
    },
    {
      meta: {
        title: '肯特大学申请季'
      },
      path: 'kente',
      name: 'KenTe',
      component: KenTe
    },
    {
      meta: {
        title: '名校顾问创造营第2期，名校官方推荐顾问证书等你来领！'
      },
      path: 'camp',
      name: 'Camp',
      component: Camp
    },
    {
      meta: {
        title: '纽卡斯尔大学'
      },
      path: 'nske',
      name: 'Nske',
      component: Nske
    },
    {
      meta: {
        title: '蒙纳士大学'
      },
      path: 'mns',
      name: 'Mns',
      component: Mns
    },
    {
      meta: {
        title: '多元教育,不被定义!伦敦大学亚非学院主题周进行中！'
      },
      path: 'lundon',
      name: 'Lundon',
      component: Lundon
    },
    {
      meta: {
        title: '名校顾问创造营第3期，名校官方推荐顾问证书等你来领！'
      },
      path: 'camp3',
      name: 'Camp3',
      component: Camp3
    },
    {
      meta: {
        title: '有颜值,有科技,有未来!悉尼科技大学&学院联合主题周进行中！'
      },
      path: 'sydney',
      name: 'Sydney',
      component: Sydney
    },
    {
      meta: {
        title: '世界百强,名校力量!西澳大学主题周进行中！'
      },
      path: 'wesAustralia',
      name: 'WesAustralia',
      component: WesAustralia
    },
    {
      meta: {
        title: '商科顶流,心动来袭!麦考瑞大学主题周进行中！'
      },
      path: 'macquarie',
      name: 'Macquarie',
      component: Macquarie
    },
    {
      meta: {
        title: '精英之路,起步名校学府!南安普顿大学主题周进行中！'
      },
      path: 'southampton',
      name: 'Southampton',
      component: Southampton
    },
    {
      meta: {
        title: '留学不奢侈,轻松HOLD住名校梦!温尼伯大学主题周!'
      },
      path: 'winnipeg',
      name: 'Winnipeg',
      component: Winnipeg
    },
    {
      meta: {
        title: '锦绣前程,创新引领未来!昆士兰大学主题周进行中！'
      },
      path: 'queensland2',
      name: 'Queensland2',
      component: Queensland2
    },
    {
      meta: {
        title: '前景钱途双在线,王牌专业等你Pick!阿德莱德大学主题周进行中！'
      },
      path: 'adelaide',
      name: 'Adelaide',
      component: Adelaide
    },
    {
      meta: {
        title: '参与名校顾问创造营，海外名校官方推荐顾问证书等你来领！'
      },
      path: 'creation',
      name: 'Creation',
      component: Creation
    },
    {
      meta: {
        title: '参与名校顾问创造营，海外名校官方推荐顾问证书等你来领！'
      },
      path: 'get-certificate',
      name: 'GetCertificate',
      component: GetCertificate
    },
    {
      meta: {
        title: '起步高科技领域,璀璨生涯由此开启!弗林德斯大学主题周进行中！'
      },
      path: 'flinders',
      name: 'Flinders',
      component: Flinders
    },
    {
      meta: {
        title: '入读全球名校,ANU助你C位出道!澳大利亚国立大学主题周进行中！'
      },
      path: 'australia',
      name: 'Australia',
      component: Australia
    },
    {
      meta: {
        title: '精英教育,从小开启!澳大利亚昆州公立中小学主题周进行中！'
      },
      path: 'kunzhou',
      name: 'KunZhou',
      component: KunZhou
    },
    {
      meta: {
        title: '高考成绩直录,名校梦想触手可及!澳大利亚蒙纳士大学主题周进行中！'
      },
      path: 'monash',
      name: 'Monash',
      component: Monash
    },
    {
      meta: {
        title: '官方专家团空降，2022低龄留学热点全解读！澳大利亚昆州公立中小学主题周进行中！'
      },
      path: 'EQI',
      name: 'EQI',
      component: EQI
    },
    {
      meta: {
        title: '澳新顶尖大学必经之路!预科课程专场主题周！'
      },
      path: 'up',
      name: 'UP',
      component: UP
    },
    {
      meta: {
        title: '实用创新，活力无限！澳大利亚迪肯大学主题周！'
      },
      path: 'diken',
      name: 'Diken',
      component: Diken
    },
    {
      meta: {
        title: '实用创新，活力无限！澳大利亚迪肯大学主题周！'
      },
      path: 'ld',
      name: 'LD',
      component: LD
    },
    {
      meta: {
        title: '跨越半球，相约Flinders！澳大利亚弗林德斯大学主题周！'
      },
      path: 'flds',
      name: 'Flds',
      component: Flds
    },
    {
      meta: {
        title: '更卓越更年轻！世界五星级+全球排名133 ！悉尼科技大学主题周~'
      },
      path: 'uts',
      name: 'UTS',
      component: UTS
    },
    {
      meta: {
        title: '选择顶尖成就卓越！澳大利亚蒙纳士大学主题周~'
      },
      path: 'mum',
      name: 'MUM',
      component: MUM
    },
    {
      meta: {
        title: '更全面更先进！圣约翰文法学校主题周~'
      },
      path: 'sjgsa',
      name: 'SJGSA',
      component: SJGSA
    },
    {
      meta:{
        title: '水之彼岸，我心所向。伍伦贡大学主题周~'
      },
      path: 'wlg',
      name: 'Wlg',
      component: Wlg
    },
    {
      meta:{
        title: '世界百强，澳洲八大-当实力与美貌并存。西澳大学主题周~'
      },
      path: 'xa',
      name: 'Xa',
      component: Xa
    },
    {
      meta:{
        title: '塔斯马尼亚大学主题周进行中！参与活动赢取惊喜红包,奖励多多！机构用户金额翻倍！'
      },
      path: 'tsmny',
      name: 'Tsmny',
      component: Tsmny
    },
    {
      meta:{
        title: '世界百强，澳洲八大-学在蒙纳士，梦圆墨尔本。蒙纳士大学主题周~'
      },
      path: 'newmns',
      name: 'newMns',
      component: newMns
    },
    {
      meta:{
        title: '世界百强，澳洲八大-我在UQ欢迎你。昆士兰大学主题周~'
      },
      path: 'newqsl',
      name: 'newQsl',
      component: newQsl
    },
    {
      meta:{
        title: '与灵感共生，同艺术共存。蒙纳士大学主题周~'
      },
      path: 'mnsb',
      name: 'mnsB',
      component: mnsB
    },
    {
      meta:{
        title: '世界50强，澳洲名校-以梦为马，开拓未来。新南威尔士大学主题周~'
      },
      path: 'xnwes',
      name: 'Xnwes',
      component: Xnwes
    },
    {
      meta:{
        title: '澳洲八大，百年名校-我在南半球，眺望世界。西澳大学主题周~'
      },
      path: 'Hftw',
      name: 'Hftw',
      component: Hftw
    },
    {
      meta:{
        title: '明天即未来，蒙纳士即希望。蒙纳士大学主题周~'
      },
      path: 'mnsdx',
      name: 'mnsdx',
      component: mnsdx
    },
    {
      meta:{
        title: '选择QUT，孵化梦想。昆士兰科技大学主题周~'
      },
      path: 'kslkj',
      name: 'kslkj',
      component: kslkj
    },
    {
      meta:{
        title: '阿德莱德大学院校日'
      },
      path: 'adldweek',
      name: 'adldweek',
      component: adldweek
    },
    {
      meta:{
        title: '学在uow,成就更好的你。伍伦贡大学主题周~'
      },
      path: 'wlgdx',
      name: 'wlgdx',
      component: wlgdx
    },
    {
      meta:{
        title: '新课程，新起点，圆你世界名校梦。奥克兰大学主题周~'
      },
      path: 'akldx',
      name: 'akldx',
      component: akldx
    },
    {
      meta:{
        title: 'QS百强大学悉尼科技大学特色课程及就业优势介绍。悉尼科技大学主题周~'
      },
      path: 'xnkj',
      name: 'xnkj',
      component: xnkj
    },
    {
      meta:{
        title: '伍伦贡大学惠在性价比，精彩看不停～ 伍伦贡大学主题周~'
      },
      path: 'wlgdxbymar',
      name: 'wlgdxbymar',
      component: wlgdxbymar
    },
    {
      meta:{
        title: '昆士兰大学热门精品课程详解，昆士兰大学主题周'
      },
      path: 'kslbymar',
      name: 'kslbymar',
      component: kslbymar
    },
    {
      meta:{
        title: '向新而行，做世界的领航家！悉尼新南威尔士大学主题周'
      },
      path: 'xnwrsMar',
      name: 'xnwrsMar',
      component: xnwrsMar
    },
    {
      meta:{
        title: '首都地区高性价比留学首选，堪培拉大学主题周'
      },
      path: 'kpldsMar',
      name: 'kpldsMar',
      component: kpldsMar
    },
    {
      meta:{
        title: '高就业实用型课程推荐！澳大利亚迪肯大学主题周'
      },
      path: 'dkdxMar',
      name: 'dkdxMar',
      component: dkdxMar
    },
    {
      meta:{
        title: '昆士兰科技大学新课程！昆士兰科技大学主题周'
      },
      path: 'KslkjdxMar',
      name: 'KslkjdxMar',
      component: KslkjdxMar
    },
    {
      meta:{
        title: '共同进步，成就非见！悉尼新南威尔士大学主题周'
      },
      path: 'Nwales',
      name: 'Nwales',
      component: Nwales
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/topic/router.js